import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const Libary = lazy(() => import('./library-page'));

const Library = () => {
  return (
    <LazyRoute>
      <Libary />
    </LazyRoute>
  );
};

export { Library };
